import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Video.scss';
import Grid from '../../../Grid/Grid';

const Video = ({ messages, formatMessage }) => (
  <div>
    <Grid container spacing={24}>
      <Grid item xs={24} md>
        <div className={s.preview}>
          <div className={s.preview__inner}>
            {formatMessage({ ...messages.video })}
          </div>
        </div>
      </Grid>
    </Grid>
  </div>
);

Video.propTypes = {
  messages: PropTypes.shape().isRequired,
  formatMessage: PropTypes.func.isRequired,
};

export default withStyles(s)(Video);
